import React, { useEffect, useState, useRef } from 'react';
import { DataManager } from '../../../core/data-manager';
import moment from 'moment';
import { Alert, Table, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';



export default function IC_customer_order_rows({ data, dataId, entity = null, setDataKeyValue }) {

    const ivaLoadedRef = useRef(false);
    const manuallyEditedFields = useRef({
        netWeight: false,
        grossWeight: false,
        packages: false,
        length: false,
        depth: false,
        height: false
    });

    async function getIVA() {
        if (entity === 'customer_order_rows') {
            var elIdIva = document.querySelector('#customer_order_field_idVatCondition *[data-id]');
            if (elIdIva) {
                var idIva = elIdIva.getAttribute('data-id');
                if (idIva && parseInt(idIva) > 0) {
                    try {
                        var r = await DataManager.getItem('vat_condition', parseInt(idIva));
                        if (r.success === 1) {
                            var iva = r.body[0]

                            if (data.idVatCondition === "" || data.idVatCondition === null) {
                                setDataKeyValue('idVatCondition', iva)
                            }
                        }
                    } catch (error) {
                        console.error('Error loading vat_condition:', error);
                    }
                }
            }
            var elPerAgente = document.querySelector('#customer_order_field_idSalesAgent *[data-id]');
            if (elPerAgente) {
                var idPerAgente = elPerAgente.getAttribute('data-id');
                if (idPerAgente && parseInt(idPerAgente) > 0) {
                    try {
                        var r = await DataManager.getItem('sales_agent', parseInt(idPerAgente));
                        if (r.success === 1) {
                            var per = r.body[0]

                            if (data.percentualeAgente === "" || data.percentualeAgente === null) {
                                setDataKeyValue('percentualeAgente', parseInt(per.percentage))
                            }
                        }
                    } catch (error) {
                        console.error('Error loading sales_agent:', error);
                    }
                }
            }
            var elPerPre = document.querySelector('#customer_order_field_idPrescrittore *[data-id]');
            if (elPerPre) {
                var idPerPre = elPerPre.getAttribute('data-id');
                if (idPerPre && parseInt(idPerPre) > 0) {
                    try {
                        var r = await DataManager.getItem('prescrittore', parseInt(idPerPre));
                        if (r.success === 1) {
                            var per = r.body[0]
                            if (data.percentualePrescrittore === "" || data.percentualePrescrittore === null) {
                                setDataKeyValue('percentualePrescrittore', parseInt(per.percentage))
                            }
                        }
                    } catch (error) {
                        console.error('Error loading prescrittore:', error);
                    }
                }
            }


            var elListino = document.querySelector('#customer_order_field_idListino *[data-id]');
            if (elListino) {
                var idListino = elListino.getAttribute('data-id');
                if (idListino && parseInt(idListino) > 0) {
                    try {
                        var r = await DataManager.getItem('listino', parseInt(idListino));
                        if (r.success === 1) {
                            var listino = r.body[0];
                            if (data.price === "") {
                                var inputPrice = document.querySelector('#customer_order_rows_field_price input');
                                if (document.activeElement !== inputPrice) {
                                    if (listino.price.value === 'price') {
                                        if (data.idItemModel && data.idItemModel.price !== null) {
                                            console.error(data.price, data.idItemModel.price)
                                            if (data.price !== data.idItemModel.price) {
                                                setDataKeyValue('price', data.idItemModel.price)
                                            }

                                        } else {
                                            if (data.price !== "0,00") {
                                                setDataKeyValue('price', "0,00")
                                            }
                                        }
                                    } else if (listino.price.value === 'price1') {
                                        if (data.idItemModel && data.idItemModel.price1 !== null) {
                                            if (data.price !== data.idItemModel.price1) {
                                                setDataKeyValue('price', data.idItemModel.price1)
                                            }

                                        } else {
                                            if (data.price !== "0,00") {
                                                setDataKeyValue('price', "0,00")
                                            }
                                        }
                                    } else if (listino.price.value === 'price2') {
                                        if (data.idItemModel && data.idItemModel.price2 !== null) {
                                            if (data.price !== data.idItemModel.price2) {
                                                setDataKeyValue('price', data.idItemModel.price2)
                                            }
                                        } else {
                                            if (data.price !== "0,00") {
                                                setDataKeyValue('price', "0,00")
                                            }
                                        }
                                    } else if (listino.price.value === 'price3') {
                                        if (data.idItemModel && data.idItemModel.price3 !== null) {
                                            if (data.price !== data.idItemModel.price3) {
                                                setDataKeyValue('price', data.idItemModel.price3)
                                            }
                                        } else {
                                            if (data.price !== "0,00") {
                                                setDataKeyValue('price', "0,00")
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        console.error('Error loading listino:', error);
                    }
                }
            }
        }
    }


    useEffect(() => {
        console.warn('DATA', data)
        if (!dataId) {
            if (!ivaLoadedRef.current && (data.idVatCondition === "" || data.idVatCondition === null)) {
                getIVA();
                ivaLoadedRef.current = true;
            }
            console.warn('righe0', data)
            if (data.idItemModel && data.idItemModel !== '' && data.idItemModel !== null) {

                var checkboxCod = document.querySelector('#customer_order_field_codiciDoganaliInFatt input');
                if ((checkboxCod && checkboxCod.checked) && data.customsCode !== data.idItemModel.customsCode) {
                    setDataKeyValue('customsCode', data.idItemModel.customsCode)
                }
                if (data.idItemModel.idMeasureUnit && data.measureUnit !== data.idItemModel.idMeasureUnit.symbol) {
                    setDataKeyValue('measureUnit', data.idItemModel.idMeasureUnit.symbol)
                }
                if (data.idItemModel.idItemModelSalesGroup && data.idItemModel.idItemModelSalesGroup.discount === "100.00") {
                    console.log(data.discount1, parseInt(data.idItemModel.idItemModelSalesGroup.discount))
                    if (data.discount1 !== parseInt(data.idItemModel.idItemModelSalesGroup.discount)) {
                        setDataKeyValue('discount1', parseInt(data.idItemModel.idItemModelSalesGroup.discount))
                        setDataKeyValue('discount2', 0)
                        setDataKeyValue('discount3', 0)
                        setDataKeyValue('discount4', 0)
                    }

                }

                // Lunghezza, profondità, altezza: precompilate, ma modificabili manualmente
                // Confronto normalizzato (converti entrambi a stringa per evitare loop)
                if (!manuallyEditedFields.current.length && String(data.length) !== String(data.idItemModel.length)) {
                    setDataKeyValue('length', data.idItemModel.length)
                }
                if (!manuallyEditedFields.current.depth && String(data.depth) !== String(data.idItemModel.depth)) {
                    setDataKeyValue('depth', data.idItemModel.depth)
                }
                if (!manuallyEditedFields.current.height && String(data.height) !== String(data.idItemModel.height)) {
                    setDataKeyValue('height', data.idItemModel.height)
                }

                if (String(data.deliveryTime) !== String(data.idItemModel.deliveryTime)) {
                    setDataKeyValue('deliveryTime', data.idItemModel.deliveryTime)
                }

                // Per articoli di picking, NON calcolare peso/volume/colli (vengono dai figli)
                const isPicking = data.idItemModel.picking === 1;

                if (!isPicking) {
                    // Peso netto: precompilato, ma modificabile manualmente (ricalcola solo se non modificato manualmente)
                    const netWeightCalc = parseFloat(data.idItemModel.netWeight) * parseFloat(data.quantity);
                    const currentNetWeight = parseFloat(data.netWeight || 0);
                    if (!isNaN(netWeightCalc) && !manuallyEditedFields.current.netWeight && Math.abs(currentNetWeight - netWeightCalc) > 0.001) {
                        setDataKeyValue('netWeight', netWeightCalc)
                    }

                    // Peso lordo: precompilato, ma modificabile manualmente (ricalcola solo se non modificato manualmente)
                    const grossWeightCalc = parseFloat(data.idItemModel.grossWeight) * parseFloat(data.quantity);
                    const currentGrossWeight = parseFloat(data.grossWeight || 0);
                    if (!isNaN(grossWeightCalc) && !manuallyEditedFields.current.grossWeight && Math.abs(currentGrossWeight - grossWeightCalc) > 0.001) {
                        setDataKeyValue('grossWeight', grossWeightCalc)
                    }

                    // Colli: precompilato, ma modificabile manualmente (ricalcola solo se non modificato manualmente)
                    if (data.idItemModel.quantityPackages && data.idItemModel.packages) {
                        const calculatedPackages = Math.ceil(parseFloat(data.quantity) / parseFloat(data.idItemModel.quantityPackages) * parseFloat(data.idItemModel.packages));
                        const currentPackages = parseInt(data.packages || 0);
                        if (!isNaN(calculatedPackages) && !manuallyEditedFields.current.packages && currentPackages !== calculatedPackages) {
                            setDataKeyValue('packages', calculatedPackages);
                        }
                    }

                    // Volume: SEMPRE calcolato come length * depth * height (in metri cubi)
                    if (data.depth && data.length && data.height) {
                        const totalVolume = (parseFloat(data.depth) / 100) * (parseFloat(data.length) / 100) * (parseFloat(data.height) / 100);
                        const currentVolume = parseFloat(data.volume || 0);
                        if (!isNaN(totalVolume) && Math.abs(currentVolume - totalVolume) > 0.01) {
                            setDataKeyValue('volume', parseFloat(totalVolume.toFixed(2)))
                        }
                    }
                }
            }
            var order = document.querySelector('#customer_order_field_orderDate input');
            if (order && order.value) {
                if (data.deliveryDate === "") {
                    if (data.idItemModel && data.idItemModel.deliveryTime === 0) {
                        console.log(order.value)
                        if (data.deliveryDate !== order.value) {
                            setDataKeyValue('deliveryDate', order.value)
                        }
                    } else if (data.idItemModel && data.idItemModel.deliveryTime !== 0) {
                        const a = data.idItemModel.deliveryTime
                        var date1 = moment(order.value, 'YYYY-MM-DD').add(a, 'week');
                        console.log(order.value, a, date1.format('YYYY-MM-DD'));
                        if (data.deliveryDate !== date1.format('YYYY-MM-DD')) {
                            setDataKeyValue('deliveryDate', date1.format('YYYY-MM-DD'))
                        }
                    }
                }


            }

            if (!data.idItemModel) {
                if (document.querySelector('#customer_order_field_discount1 input')) {
                    var d1 = parseFloat(document.querySelector('#customer_order_field_discount1 input').value);
                    if (d1 !== 0 && parseFloat(data.discount1) !== d1) {
                        setDataKeyValue('discount1', d1)
                    }
                }
            }
            if (!data.idItemModel) {
                if (document.querySelector('#customer_order_field_discount2 input')) {
                    var d1 = parseFloat(document.querySelector('#customer_order_field_discount2 input').value);
                    if (d1 !== 0 && parseFloat(data.discount2) !== d1) {
                        setDataKeyValue('discount2', d1)
                    }
                }
            }
            if (!data.idItemModel) {
                if (document.querySelector('#customer_order_field_discount3 input')) {
                    var d1 = parseFloat(document.querySelector('#customer_order_field_discount3 input').value);
                    if (d1 !== 0 && parseFloat(data.discount3) !== d1) {
                        setDataKeyValue('discount3', d1)
                    }
                }
            }
            if (!data.idItemModel) {
                if (document.querySelector('#customer_order_field_discount4 input')) {
                    var d1 = parseFloat(document.querySelector('#customer_order_field_discount4 input').value);
                    if (d1 !== 0 && parseFloat(data.discount4) !== d1) {
                        setDataKeyValue('discount4', d1)
                    }
                }
            }
            if (!data.idItemModel) {
                if (document.querySelector('#customer_order_field_discount5 input')) {
                    var d1 = parseFloat(document.querySelector('#customer_order_field_discount5 input').value);
                    if (d1 !== 0 && parseFloat(data.discount5) !== d1) {
                        setDataKeyValue('discount5', d1)
                    }
                }
            }
            if (data.price !== "" && data.quantity !== "") {
                var a = (parseFloat(data.price) * parseInt(data.quantity))
                console.log(a, data.totalRow)
                if (a === 0) {
                    if (data.totalRow !== "0.00") {
                        setDataKeyValue('totalRow', "0.00")
                    }
                } else {
                    if (data.idItemModel.idItemModelSalesGroup && data.idItemModel.idItemModelSalesGroup.discount === "100.00") {
                        if (parseFloat(data.totalRow ? data.totalRow : 0).toFixed(2) !== a.toFixed(2)) {
                            setDataKeyValue('totalRow', a.toFixed(2))
                        }
                    } else {

                        if (data.discount1) {
                            a = a - (a * parseFloat(data.discount1)) / 100
                        }
                        if (data.discount2) {
                            a = a - (a * parseFloat(data.discount2)) / 100
                        }
                        if (data.discount3) {
                            a = a - (a * parseFloat(data.discount3)) / 100
                        }
                        if (data.discount4) {
                            a = a - (a * parseFloat(data.discount4)) / 100
                        }
                        if (data.discount5) {
                            a = a - (a * parseFloat(data.discount5)) / 100
                        }
                        if (parseInt(a) === 0) {
                            if (parseFloat(data.totalRow) !== parseFloat(a)) {
                                setDataKeyValue('totalRow', parseFloat(a).toFixed(2))
                            }

                        } else {
                            if (parseFloat(data.totalRow ? data.totalRow : 0).toFixed(2) !== parseFloat(a).toFixed(2)) {
                                setDataKeyValue('totalRow', parseFloat(a).toFixed(2))
                            }
                        }


                    }
                }


            }
            if (data.totalRow && data.totalRow !== "" && data.idVatCondition) {
                var a = parseFloat(data.totalRow) * (parseFloat(data.idVatCondition.percentage) / 100)
                if (data.totalIva !== a.toFixed(2)) {
                    setDataKeyValue('totalIva', a.toFixed(2));
                }
            }
            if (data.totalIva !== "" && data.totalRow !== "") {
                var a = parseFloat(data.totalRow) + parseFloat(data.totalIva)
                if (data.total !== a.toFixed(2)) {
                    setDataKeyValue('total', a.toFixed(2));
                }
            }
        } else {
            // Modalità modifica (dataId presente)

            // Per articoli di picking, NON calcolare peso/volume/colli (vengono dai figli)
            const isPicking = data.idItemModel?.picking === 1;

            if (!isPicking) {
                // Peso netto: ricalcola solo se non modificato manualmente
                const netWeightCalc = parseFloat(data.idItemModel.netWeight) * parseFloat(data.quantity);
                const currentNetWeight = parseFloat(data.netWeight || 0);
                if (!isNaN(netWeightCalc) && !manuallyEditedFields.current.netWeight && Math.abs(currentNetWeight - netWeightCalc) > 0.001) {
                    setDataKeyValue('netWeight', netWeightCalc)
                }

                // Peso lordo: ricalcola solo se non modificato manualmente
                const grossWeightCalc = parseFloat(data.idItemModel.grossWeight) * parseFloat(data.quantity);
                const currentGrossWeight = parseFloat(data.grossWeight || 0);
                if (!isNaN(grossWeightCalc) && !manuallyEditedFields.current.grossWeight && Math.abs(currentGrossWeight - grossWeightCalc) > 0.001) {
                    setDataKeyValue('grossWeight', grossWeightCalc)
                }

                // Volume: SEMPRE calcolato come length * depth * height (in metri cubi)
                if (data.depth && data.length && data.height) {
                    const totalVolume = (parseFloat(data.depth) / 100) * (parseFloat(data.length) / 100) * (parseFloat(data.height) / 100);
                    const currentVolume = parseFloat(data.volume || 0);
                    if (!isNaN(totalVolume) && Math.abs(currentVolume - totalVolume) > 0.01) {
                        setDataKeyValue('volume', parseFloat(totalVolume.toFixed(2)))
                    }
                }
            }

            var checkboxCod = document.querySelector('#customer_order_field_codiciDoganaliInFatt input');
            if ((checkboxCod && checkboxCod.checked) && data.customsCode !== data.idItemModel.customsCode) {
                setDataKeyValue('customsCode', data.idItemModel.customsCode)
            }


            if (data.price !== "" && data.quantity !== "") {
                var a = (parseFloat(data.price) * parseInt(data.quantity))
                if (a === 0) {
                    if (data.totalRow !== "0.00") {
                        setDataKeyValue('totalRow', "0.00")
                    }
                } else {
                    if (data.idItemModel.idItemModelSalesGroup && data.idItemModel.idItemModelSalesGroup.discount === "100.00") {
                        if (parseFloat(data.totalRow ? data.totalRow : 0).toFixed(2) !== a.toFixed(2)) {
                            setDataKeyValue('totalRow', a.toFixed(2))
                        }
                    } else {

                        if (data.discount1) {
                            a = a - (a * parseFloat(data.discount1)) / 100
                        }
                        if (data.discount2) {
                            a = a - (a * parseFloat(data.discount2)) / 100
                        }
                        if (data.discount3) {
                            a = a - (a * parseFloat(data.discount3)) / 100
                        }
                        if (data.discount4) {
                            a = a - (a * parseFloat(data.discount4)) / 100
                        }
                        if (data.discount5) {
                            a = a - (a * parseFloat(data.discount5)) / 100
                        }

                        if (parseInt(a) === 0) {
                            if (parseFloat(data.totalRow) !== parseFloat(a)) {
                                setDataKeyValue('totalRow', parseFloat(a).toFixed(2))
                            }

                        } else {
                            if (parseFloat(data.totalRow ? data.totalRow : 0).toFixed(2) !== parseFloat(a).toFixed(2)) {
                                setDataKeyValue('totalRow', parseFloat(a).toFixed(2))
                            }
                        }


                    }
                }


            }
            if (data.totalRow && data.totalRow !== "" && data.idVatCondition) {
                var a = parseFloat(data.totalRow) * (parseFloat(data.idVatCondition.percentage) / 100)
                if (data.totalIva !== a.toFixed(2)) {
                    setDataKeyValue('totalIva', a.toFixed(2));
                }
            }
            if (data.totalIva !== "" && data.totalRow !== "") {
                var a = parseFloat(data.totalRow) + parseFloat(data.totalIva)
                if (data.total !== a.toFixed(2)) {
                    setDataKeyValue('total', a.toFixed(2));
                }
            }
        }
    }, [data])


    async function calculatePickingPrice() {
        try {
            const constraints = [
                { fieldName: "idItemModel", type: "value", value: data.idItemModel.id },
            ];
            const sorting = { field: 'id', order: 'desc' };
            const res = await DataManager.searchItems('manufacturing_process_model', 1, 100, sorting, '', [], constraints);
            if (res.success === 1 && res.body.length > 0) {
                let totalPrice = 0;
                const children = res.body[0].children || [];
                for (const child of children) {
                    if (child.idItemModel && child.idItemModel.price) {
                        totalPrice += parseFloat(child.idItemModel.price) * parseFloat(child.quantity || 1);
                    }
                }
                const newPrice = totalPrice.toFixed(2);
                if (parseFloat(data.price || 0).toFixed(2) !== newPrice) {
                    setDataKeyValue('price', newPrice);
                }
            }
        } catch (error) {
            console.error('Error calculating picking price:', error);
        }
    }

    useEffect(() => {
        if (!dataId) {
            if (data.idItemModel && data.idItemModel !== '' && data.idItemModel !== null) {
                // Per articoli di picking, il prezzo è la somma dei prezzi dei figli
                if (data.idItemModel.picking === 1) {
                    calculatePickingPrice();
                } else {
                    if (data.price !== data.idItemModel.price) {
                        setDataKeyValue('price', data.idItemModel.price)
                    }
                }
                if (data.name !== data.idItemModel.name) {
                    setDataKeyValue('name', data.idItemModel.name)
                }
                if (data.length !== data.idItemModel.length) {
                    setDataKeyValue('length', data.idItemModel.length)
                }
                if (data.depth !== data.idItemModel.depth) {
                    setDataKeyValue('depth', data.idItemModel.depth)
                }
                if (data.height !== data.idItemModel.height) {
                    setDataKeyValue('height', data.idItemModel.height)
                }
            }
        }
        if (data.idItemModel?.id) {
            getQuantities()
        }
    }, [data.idItemModel?.id])



    useEffect(() => {
        if (!dataId) {
            if (data.measureUnit === "PZ") {
                if (!Number.isInteger(parseFloat(data.quantity))) {
                    toast.error("La quantità deve essere un numero senza virgola.", { theme: 'colored' })
                }
            }
        }
    }, [data.quantity])

    // Traccia le modifiche manuali sui campi
    useEffect(() => {
        const netWeightInput = document.querySelector('#customer_order_rows_field_netWeight input');
        const grossWeightInput = document.querySelector('#customer_order_rows_field_grossWeight input');
        const packagesInput = document.querySelector('#customer_order_rows_field_packages input');
        const lengthInput = document.querySelector('#customer_order_rows_field_length input');
        const depthInput = document.querySelector('#customer_order_rows_field_depth input');
        const heightInput = document.querySelector('#customer_order_rows_field_height input');

        const handleNetWeightChange = () => {
            manuallyEditedFields.current.netWeight = true;
        };
        const handleGrossWeightChange = () => {
            manuallyEditedFields.current.grossWeight = true;
        };
        const handlePackagesChange = () => {
            manuallyEditedFields.current.packages = true;
        };
        const handleLengthChange = () => {
            manuallyEditedFields.current.length = true;
        };
        const handleDepthChange = () => {
            manuallyEditedFields.current.depth = true;
        };
        const handleHeightChange = () => {
            manuallyEditedFields.current.height = true;
        };

        if (netWeightInput) {
            netWeightInput.addEventListener('input', handleNetWeightChange);
        }
        if (grossWeightInput) {
            grossWeightInput.addEventListener('input', handleGrossWeightChange);
        }
        if (packagesInput) {
            packagesInput.addEventListener('input', handlePackagesChange);
        }
        if (lengthInput) {
            lengthInput.addEventListener('input', handleLengthChange);
        }
        if (depthInput) {
            depthInput.addEventListener('input', handleDepthChange);
        }
        if (heightInput) {
            heightInput.addEventListener('input', handleHeightChange);
        }

        return () => {
            if (netWeightInput) {
                netWeightInput.removeEventListener('input', handleNetWeightChange);
            }
            if (grossWeightInput) {
                grossWeightInput.removeEventListener('input', handleGrossWeightChange);
            }
            if (packagesInput) {
                packagesInput.removeEventListener('input', handlePackagesChange);
            }
            if (lengthInput) {
                lengthInput.removeEventListener('input', handleLengthChange);
            }
            if (depthInput) {
                depthInput.removeEventListener('input', handleDepthChange);
            }
            if (heightInput) {
                heightInput.removeEventListener('input', handleHeightChange);
            }
        };
    }, []);

    // Reset dei flag quando cambia l'articolo
    useEffect(() => {
        manuallyEditedFields.current = {
            netWeight: false,
            grossWeight: false,
            packages: false,
            length: false,
            depth: false,
            height: false
        };
    }, [data.idItemModel?.id]);

    // Disabilita i campi dimensionali se l'articolo è di picking
    useEffect(() => {
        if (data.idItemModel && data.idItemModel.picking === 1) {
            // Disabilita i campi: length, depth, height, netWeight, grossWeight, volume, packages
            const fieldsToDisable = [
                '#customer_order_rows_field_length input',
                '#customer_order_rows_field_depth input',
                '#customer_order_rows_field_height input',
                '#customer_order_rows_field_netWeight input',
                '#customer_order_rows_field_grossWeight input',
                '#customer_order_rows_field_volume input',
                '#customer_order_rows_field_packages input'
            ];

            fieldsToDisable.forEach(selector => {
                const field = document.querySelector(selector);
                if (field) {
                    field.disabled = true;
                    field.style.backgroundColor = '#e9ecef';
                }
            });
        } else {
            // Riabilita i campi se l'articolo non è più di picking
            const fieldsToEnable = [
                '#customer_order_rows_field_length input',
                '#customer_order_rows_field_depth input',
                '#customer_order_rows_field_height input',
                '#customer_order_rows_field_netWeight input',
                '#customer_order_rows_field_grossWeight input',
                '#customer_order_rows_field_volume input',
                '#customer_order_rows_field_packages input'
            ];

            fieldsToEnable.forEach(selector => {
                const field = document.querySelector(selector);
                if (field) {
                    field.disabled = false;
                    field.style.backgroundColor = '';
                }
            });
        }
    }, [data.idItemModel?.picking, data.idItemModel?.id])


    const [quantities, setQuantities] = useState(null);
    const [loadingQuantities, setLoadingQuantities] = useState(false);

    async function getQuantities() {
        setLoadingQuantities(true);
        setQuantities(null);
        var temp = []
        if (data?.idItemModel?.picking === 1) {
            var constraintsC = [
                { fieldName: "idItemModel", type: "value", value: data.idItemModel.id },
            ]
            var sortingC = {
                'field': 'id',
                'order': 'desc'
            }
            try {
                var resChildren = await DataManager.searchItems('manufacturing_process_model', 1, 100, sortingC, '', [], constraintsC);
                if (resChildren.success === 1) {
                    console.log(resChildren)
                    for (let i = 0; i < resChildren.body[0].children.length; i++) {
                        var constraints = [
                            { fieldName: "id", type: "value", value: resChildren.body[0].children[i].idItemModel.id },
                        ]
                        var sorting = {
                            'field': 'id',
                            'order': 'desc'
                        }
                        var res = await DataManager.searchItemsSimple('gyv_stocks', 1, 100, sorting, '', [], constraints);
                        if (res.success === 1) {
                            const child = resChildren.body[0].children[i];
                            temp.push({
                                ...res.body[0],
                                childPrice: parseFloat(child.idItemModel.price || 0),
                                childQuantity: parseFloat(child.quantity || 1)
                            });
                        }
                    }
                    console.log(temp)
                    setQuantities(temp)
                }
            } finally {
                setLoadingQuantities(false);
            }


        } else {
            var constraints = [
                { fieldName: "id", type: "value", value: data.idItemModel.id },
            ]
            var sorting = {
                'field': 'id',
                'order': 'desc'
            }
            try {
                var res = await DataManager.searchItemsSimple('gyv_stocks', 1, 100, sorting, '', [], constraints);
                if (res.success === 1) {
                    setQuantities(res.body)
                }
            } finally {
                setLoadingQuantities(false);
            }
        }

    }




    return (
        <>
            {loadingQuantities ? <>
                <Alert>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Descrizione articolo</th>
                                <th>Giacenza interna</th>
                                <th>Quantità</th>
                                <th>Prezzo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={4} className='text-center'>
                                    <Spinner animation="border" size="sm" className='me-2' />
                                    Caricamento quantità...
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Alert>
            </> : null}

            {!loadingQuantities && quantities && quantities.length > 0 ? <>
                <Alert>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Descrizione articolo</th>
                                <th>Giacenza interna</th>
                                <th>Quantità</th>
                                <th>Prezzo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {quantities && quantities.map((item, i) => {
                                return (<>
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>{item.stockQuantityInternal}</td>
                                        <td>{item.childQuantity != null ? item.childQuantity * parseInt(data.quantity || 1) : '-'}</td>
                                        <td>{item.childPrice != null ? item.childPrice.toFixed(2) : (data.idItemModel?.price || '-')} €</td>
                                    </tr>
                                </>)
                            })}

                        </tbody>
                    </Table>
                </Alert>
            </> : null}


        </>
    )
};
